import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import DropdownMenu from '@atlaskit/dropdown-menu/dropdown-menu';
import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';
import DropdownItemGroup from '@atlaskit/dropdown-menu/dropdown-menu-item-group';
import FeedbackIcon from '@atlaskit/icon/core/feedback';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';

import { feedbackCollectorMessages } from '../page/FeedbackCollectorButton.tsx';
import { PageActionsFeedbackCollector } from '../page/PageActionsFeedbackCollector.tsx';

const LEARN_MORE_ROLES =
	'https://support.atlassian.com/confluence-cloud/docs/what-are-confluences-roles/';

const i18n = defineMessages({
	learnMoreLink: {
		id: 'space-roles.modal-header-actions-menu.learn-more-link',
		defaultMessage: 'Learn more about roles',
		description: 'Link in the more options menu to learn more about Confluence roles',
	},
	moreOptionsLabel: {
		id: 'space-roles.modal-header-actions-menu.more-options-label',
		defaultMessage: 'More options',
		description: 'Accessible label for the more options icon button in the modal header',
	},
});

export const ModalHeaderActionsMenu = ({ source }: { source: string }): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

	return (
		<React.Fragment>
			<PageActionsFeedbackCollector
				isOpen={isFeedbackOpen}
				onClose={() => setIsFeedbackOpen(false)}
				source={source}
			/>
			<DropdownMenu<HTMLButtonElement>
				placement="bottom-end"
				trigger={({ triggerRef, ...props }) => (
					<IconButton
						{...props}
						appearance="subtle"
						icon={ShowMoreHorizontalIcon}
						label={formatMessage(i18n.moreOptionsLabel)}
						ref={triggerRef}
					/>
				)}
				shouldRenderToParent
			>
				<DropdownItemGroup>
					<DropdownItem onClick={() => window.open(LEARN_MORE_ROLES, '_blank')}>
						{formatMessage(i18n.learnMoreLink)}
					</DropdownItem>
					<DropdownItem
						elemBefore={<FeedbackIcon label="" />}
						onClick={() => setIsFeedbackOpen(true)}
					>
						{formatMessage(feedbackCollectorMessages.buttonText)}
					</DropdownItem>
				</DropdownItemGroup>
			</DropdownMenu>
		</React.Fragment>
	);
};
